import api from './api'

export const suscripcionClinicaService = {
  /**
   * Obtener todas las suscripciones del usuario autenticado
   */
  async getAll() {
    const response = await api.get('/suscripciones-clinicas')
    return response.data
  },

  /**
   * Suscribirse a una clínica
   */
  async subscribe(idClinica) {
    const response = await api.post('/suscripciones-clinicas', {
      id_clinica: idClinica
    })
    return response.data
  },

  /**
   * Darse de baja de una clínica
   */
  async unsubscribe(idSuscripcion, motivoBaja = null) {
    const response = await api.delete(`/suscripciones-clinicas/${idSuscripcion}`, {
      data: { motivo_baja: motivoBaja }
    })
    return response.data
  },

  /**
   * Obtener clínicas disponibles para suscribirse
   */
  async getClinicasDisponibles() {
    const response = await api.get('/suscripciones-clinicas/clinicas-disponibles')
    return response.data
  },

  /**
   * Obtener historial completo de suscripciones
   */
  async getHistorial() {
    const response = await api.get('/suscripciones-clinicas/historial')
    return response.data
  },

  /**
   * Obtener suscripciones pendientes (para veterinario admin)
   */
  async getPendientes() {
    const response = await api.get('/suscripciones-clinicas/pendientes')
    return response.data
  },

  /**
   * Agregar mascotas a una suscripción (selección manual o todas)
   */
  async agregarMascotas(idSuscripcion, { mascotas, todasMisMascotas = false } = {}) {
    const payload = {}
    if (Array.isArray(mascotas) && mascotas.length > 0) {
      payload.mascotas = mascotas
    }
    if (todasMisMascotas) {
      payload.todas_mis_mascotas = true
    }
    const response = await api.post(`/suscripciones-clinicas/${idSuscripcion}/mascotas`, payload)
    return response.data
  },

  /**
   * Quitar mascotas de una suscripción
   */
  async quitarMascotas(idSuscripcion, mascotas) {
    const response = await api.delete(`/suscripciones-clinicas/${idSuscripcion}/mascotas`, {
      data: { mascotas },
    })
    return response.data
  },

  /**
   * Aprobar una suscripción (para veterinario admin)
   */
  async aprobar(idSuscripcion) {
    const response = await api.post(`/suscripciones-clinicas/${idSuscripcion}/aprobar`)
    return response.data
  },

  /**
   * Rechazar una suscripción (para veterinario admin)
   */
  async rechazar(idSuscripcion, motivoRechazo = null) {
    const response = await api.post(`/suscripciones-clinicas/${idSuscripcion}/rechazar`, {
      motivo_rechazo: motivoRechazo
    })
    return response.data
  },
}

